import React from "react";
import { FormattedMessage } from "react-intl";

export const validationErrors = {
  email: <FormattedMessage id="validEmail" />,
  required: <FormattedMessage id="required" />,
  phoneNumber: <FormattedMessage id="validPhone" />,
  passwordNotMatch: <FormattedMessage id="passwordNotMatch" />,
};
